<div class="toolbar">
  <div kendoTypography variant="h2">{{ "MEDIKO_LOGO_TEXT" | translate }}</div>
  <ng-container
    *ngIf="
      isLoggedIn &&
      !auth.isMedikoUser &&
      accountManagers &&
      accountManagers.length > 0
    "
  >
    <div class="account-manager-info" *ngFor="let worker of accountManagers">
      <div>
        <span class="k-icon k-i-user"></span
        >{{ worker.firstName + " " + worker.lastName }}
      </div>
      <div>
        <span class="k-icon k-i-email"></span
        ><a [attr.href]="'mailto:' + worker.email">{{ worker.email }}</a>
      </div>
      <div><span class="k-icon k-i-rss"></span>{{ worker.mobilePhone }}</div>
    </div>
  </ng-container>
  <ng-container *ngIf="isLoggedIn && auth.isMedikoUser && userInfo">
    <div class="account-manager-info">
      <div>
        <span class="k-icon k-i-user"></span
        >{{ userInfo.firstName + " " + userInfo.lastName }}
      </div>
    </div>
  </ng-container>
</div>
